import {Component, Input, OnInit} from '@angular/core';
import {MuacUtil} from '../../util/muac.util';

@Component({
    selector: 'muac-box',
    templateUrl: './muac.component.html',
    styleUrls: ['./muac.component.scss']
})
export class MuacComponent implements OnInit {

    @Input()
    public muac: number;
    @Input()
    public marker: string = 'no_measured';

    constructor() {
    }

    public muacFormatter() {
        return this.marker;
    }

    ngOnInit() {
    }

}
